import { getGoalSiteAri } from '@atlassian/projects-goals-common/get-app-site-ari';
import { addMonths } from 'date-fns';
import { PreloadedQuery } from 'react-relay';

import { formatIsoLocalDateTime } from '@townsquare/date-utils/format';
import { getUtcEndOfGoalMonth, parseGoalUpdatesFeedStartDate } from '@townsquare/date-utils/update';
import { createRelayResource, type RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import GoalUpdatesViewAggQuery, {
	type GoalUpdatesViewAggQuery as GoalUpdatesViewAggQueryType,
} from '../GoalUpdatesView/agg/__generated__/GoalUpdatesViewAggQuery.graphql';
import { getUpdateStateFilterFromQueryParams } from '../components/UpdateStateFilter';

export const goalUpdatesViewAggResource: RouteResource<
	PreloadedQuery<GoalUpdatesViewAggQueryType, Record<string, unknown>>
> = createRelayResource<GoalUpdatesViewAggQueryType>({
	getQuery: (routerContext, resourceContext): RelayResourceConfig<GoalUpdatesViewAggQueryType> => {
		const { collabContext, user } = resourceContext as ResourceContext;
		const utcStartDate = parseGoalUpdatesFeedStartDate(routerContext.query.start);
		const utcPrevDate = addMonths(utcStartDate, -1);
		const utcEndDate = getUtcEndOfGoalMonth(utcStartDate);

		return {
			query: GoalUpdatesViewAggQuery,
			variables: {
				containerId: getGoalSiteAri(collabContext?.contextId || ''),
				prevDate: formatIsoLocalDateTime(utcPrevDate),
				startDate: formatIsoLocalDateTime(utcStartDate),
				endDate: formatIsoLocalDateTime(utcEndDate),
				stateFilter: getUpdateStateFilterFromQueryParams(routerContext.query.filter),
				followingGoalsSearchString: tqlQueryFromInput({
					input: [
						{
							fieldName: 'watcher',
							fieldValue: user.accountId,
							comparator: ComparatorOperator.EQUALS,
						},
						{
							fieldName: 'archived',
							fieldValue: false,
							comparator: ComparatorOperator.EQUALS,
						},
					],
				}),
			},
			environment: getAggRelayEnvironment(),
			options: {
				fetchPolicy: 'store-and-network',
			},
		};
	},
});
